import { render, staticRenderFns } from "./Cn-COA-Powder.vue?vue&type=template&id=196594f9&scoped=true&"
import script from "./Cn-COA-Powder.vue?vue&type=script&lang=js&"
export * from "./Cn-COA-Powder.vue?vue&type=script&lang=js&"
import style0 from "./Cn-COA-Powder.vue?vue&type=style&index=0&id=196594f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196594f9",
  null
  
)

export default component.exports